/* This file is autogenerated, see readme.md for instructions */
import SwapSvgIcon from '@bloomreach/banana-theme/icons/swap.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SwapIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SwapSvgIcon />
    </Icon>
  );
});

SwapIcon.displayName = 'SwapIcon';

export default SwapIcon;
